// Real product box images.
// Keyed by package id → /public path.

export const PACKAGE_IMAGES = {
  "bow-tie-lite":       `${process.env.PUBLIC_URL || ""}/website-boxes/bow-tie-lite.png`,
  "classic-knot":       `${process.env.PUBLIC_URL || ""}/website-boxes/classic-knot.png`,
  "windsor-growth":     `${process.env.PUBLIC_URL || ""}/website-boxes/windsor-growth.jpg`,
  "black-label-studio": `${process.env.PUBLIC_URL || ""}/website-boxes/black-label-studio.jpg`,
};

export const FUNNEL_IMAGES = {
  "concierge-start":  `${process.env.PUBLIC_URL || ""}/funnel-boxes/concierge-start.png`,
  "concierge-plus":   `${process.env.PUBLIC_URL || ""}/funnel-boxes/concierge-plus.jpg`,
  "concierge-pro":    `${process.env.PUBLIC_URL || ""}/funnel-boxes/concierge-pro.jpg`,
  "concierge-elite":  `${process.env.PUBLIC_URL || ""}/funnel-boxes/concierge-elite.jpg`,
};

export const HERO_LINEUP_IMAGE =
  "https://customer-assets.emergentagent.com/job_web-makeover-69/artifacts/omjddhnm_image.png";
